import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkPrivateGetParamsRaw,
	type LWApiPublicNetworkPrivateGetResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/private/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_PRIVATE_GET_QUERY_KEY = '/network/private/get';

const useNetworkPrivateGet = (
	params: LWApiPublicNetworkPrivateGetParamsRaw,
	options?: UseQueryOptions<LWApiPublicNetworkPrivateGetResultRaw, ApiErrorI>,
) =>
	useQuery({
		queryKey: [NETWORK_PRIVATE_GET_QUERY_KEY, params],
		queryFn: () => api.network.private.apiRaw.get(params),
		...options,
	});

export default useNetworkPrivateGet;
